import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

interface ProgrammesIconProps extends SvgIconProps {
  htmlColor?: string;
  fontSize?: "small" | "inherit" | "large" | "medium";
}

export default function ProgrammesIcon({
  htmlColor,
  fontSize,
  ...props
}: ProgrammesIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" fill="none" fontSize={fontSize} {...props}>
      <path
        d="M2.07006 4.60086C2.87006 1.14086 8.08006 1.14086 8.87006 4.60086C9.34006 6.63086 8.05006 8.35086 6.93006 9.42086C6.11006 10.2009 4.82006 10.1909 4.00006 9.42086C2.89006 8.35086 1.60006 6.63086 2.07006 4.60086Z"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M15.07 16.6009C15.87 13.1409 21.11 13.1409 21.91 16.6009C22.38 18.6309 21.09 20.3509 19.96 21.4209C19.14 22.2009 17.84 22.1909 17.02 21.4209C15.89 20.3509 14.6 18.6309 15.07 16.6009Z"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M12.0002 5H14.6802C16.5302 5 17.3902 7.29 16.0002 8.51L8.01019 15.5C6.62019 16.71 7.48019 19 9.32019 19H12.0002"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M5.48622 5.5H5.49777"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M18.4862 17.5H18.4978"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
